// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__qTjch","forgot_password":"Login_forgot_password__iJJCy"};